export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT OUTAREA.c046eec5.jpg";